import React, {useContext, useEffect, useState} from 'react'
import DB from '../DAL/DB'
import {ReducerContext, wrap} from "./reducer"
import {Tabs} from 'antd'
import './Analytics.scss'
import {Dropdowns, Tables, Chart, SOTable, OSPlot} from '.'
import {GenericSelector} from './GenericSelector'
import {useAllOrgs, useAllUsers, useRollingAverages} from './effects'

const {TabPane} = Tabs
const analytics = new DB.Analytics()

export function Analytics() {
  const {state, dispatch} = useContext(ReducerContext)
  const activeTab = state.activeTab || "1"
  
  useEffect(() => {
    const loadSOData = async () => {
      if (activeTab === "2" && state.dropdown.rubric) {
        const aggregations = new DB.Aggregations()
        // Determine which aggregation type to use
        const aggType = state.dropdown.aggregation === 'reviewer' 
          ? 'reviewer' 
          : state.dropdown.aggregation === 'installer'
            ? 'installer'
            : 'field_user';
        
        const {ok, data} = await aggregations.get(null, {
          filters: [
            [`rubric`, `==`, state.dropdown.rubric],
            [`aggregation_type`, `==`, aggType],
          ],
        })

        if (ok && data && data.length > 0) {
          dispatch({type: `SO_data`, value: data[0]})
        }
      }
    }

    loadSOData()
  }, [activeTab, state.dropdown.rubric, state.dropdown.aggregation, state.dropdown.fieldUser, state.dropdown.reviewer, state.dropdown.installerUser])

  useEffect(function () {
    (async function () {
      const {ok, data} = await analytics.get()
      //console.log('Fetched forms for dropdown:', {ok, data})
      if (ok) {
        const uniqueForms = {}
        for (let resource of data) {
          const formId = resource.form_id || resource.id
          if (!uniqueForms[formId]) {
            uniqueForms[formId] = {id: formId, title: resource.form_title || resource.title}
          }
        }
        dispatch({type: 'forms', value: Object.values(uniqueForms)})
      }
    })()
  }, [])

  useAllOrgs()
  useAllUsers()
  useRollingAverages(activeTab)

  const handleTabChange = (key) => {
    dispatch({ type: 'setActiveTab', value: key })
  }

  const intervalOptions = [
    { id: '7_day', interval_name: '7 days' },
    { id: '30_day', interval_name: '30 days' },
    { id: '90_day', interval_name: '90 days' },
    { id: '180_day', interval_name: '180 days' },
    { id: '365_day', interval_name: '365 days' },
    { id: 'all_time', interval_name: 'All Time' },
  ]
  const handleIntervalChange = (value) => {
    dispatch({ type: 'interval', value })
  }
  //console.log('active tab:', state.activeTab)

  return (
    <div className="analytics-page">
      <h1 className="page-title">Analytics</h1>      
      <div style={{ marginBottom: 24 }}>
        <Dropdowns />
      </div>
      <div style={{ padding: '0 32px' }}>
        <Tabs activeKey={activeTab} size="large" onChange={handleTabChange}>
          <TabPane tab="Continuing Improvement" key="1" data-cy="continuingImprovement">
            <Chart />
          </TabPane>
          <TabPane tab="Statistical Outliers" key="2" data-cy="statisticalOutliers">
            <Tabs defaultActiveKey="soTable" size="small" style={{ marginBottom: 16 }}>
              <TabPane tab="Comprehensive View" key="soTable">
                <SOTable />
              </TabPane>
              <TabPane tab="Summary View" key="tables">
                <Tables /> 
              </TabPane>
            </Tabs>
          </TabPane>
          <TabPane tab="Overall Score" key="3" data-cy="overallScore">
            <div style={{ marginBottom: 16, width: 200, marginLeft: 'auto' }}>
              <GenericSelector
                placeholder="Select Interval"
                values={intervalOptions}
                valueTitle="interval_name"
                selectedValue={state.dropdown.interval || '30_day'}
                onChange={handleIntervalChange}
              />
            </div>
            <OSPlot />
          </TabPane>
        </Tabs>
      </div>
    </div>
  )
}

const WrappedAnalytics = wrap(Analytics)
export default WrappedAnalytics

